import { createPromise } from "./createPromise";

export const waitFor = (clause, interval = 1000, timeout = 60000) => {
  const { promise, resolve, reject } = createPromise();

  const intervalId = setInterval(() => {
    const res = clause();
    if (!res) return;

    resolve(res);
    clearInterval(intervalId);
    // eslint-disable-next-line no-use-before-define
    clearTimeout(timeoutId);
  }, interval);

  const timeoutId = setTimeout(() => {
    reject(new Error(`Timeout ${timeout} reached`));
    clearInterval(intervalId);
  }, timeout);

  return promise;
};
